// extracted by mini-css-extract-plugin
export default {"top":"QuestionVariableConfiguration_top__Wgp+c"};